<vex-page-layout>
  <vex-page-layout-header class="dashboard-header flex items-center">
    <div class="dashboard-header-row">
      <div class="dashboard-header-titles">
        <h1 class="title dashboard-title">Dashboard</h1>
        <vex-breadcrumbs [crumbs]="breadcrumbs"></vex-breadcrumbs>
      </div>
      <label *ngIf="canViewMetrics && canViewAll" class="scope-toggle">
        <span [class.scope-option--active]="scope === 'mine'">My Clients</span>
        <mat-slide-toggle
          color="primary"
          disableRipple
          [checked]="scope === 'all'"
          (change)="onScopeChange($event.checked ? 'all' : 'mine')">
        </mat-slide-toggle>
        <span [class.scope-option--active]="scope === 'all'">All Clients</span>
      </label>
    </div>
  </vex-page-layout-header>

  <vex-page-layout-content class="dashboard-content">
    <vex-enrollment-duplicates-alert *ngIf="canViewEnrollmentDuplicatesAlert"></vex-enrollment-duplicates-alert>
    <ng-container *ngIf="canViewMetrics">
      <vex-dashboard-metrics [scope]="scope"></vex-dashboard-metrics>
      <section class="dashboard-section">
        <div class="section-label">
          <span class="section-bar section-bar--accounts"></span>
          <span>Client Accounts</span>
        </div>
        <div class="dashboard-widget-row">
          <vex-recently-assigned-widget [scope]="scope"></vex-recently-assigned-widget>
          <vex-accounts-needing-attention-widget [scope]="scope"></vex-accounts-needing-attention-widget>
        </div>
      </section>
      <section class="dashboard-section">
        <div class="section-label">
          <span class="section-bar section-bar--enrollment"></span>
          <span>Enrollment</span>
        </div>
        <div class="dashboard-widget-row">
          <vex-upcoming-open-enrollment-widget [scope]="scope"></vex-upcoming-open-enrollment-widget>
          <vex-enrollments-awaiting-acknowledgement-widget [scope]="scope"></vex-enrollments-awaiting-acknowledgement-widget>
        </div>
      </section>
      <vex-members-over-time-widget [scope]="scope"></vex-members-over-time-widget>
    </ng-container>
  </vex-page-layout-content>
</vex-page-layout>
